import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { SvgInlineDirective } from '../../../shared/directives/svg/svg-inline.directive';
import { RouterModule } from '@angular/router';
import { ContactData } from '../../../core/data-models/contactData';
import { ContactUsService } from '../../../core/services/contactUs.service';
import { Router } from '@angular/router';
import { FooterService } from '../../../core/services/footer.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Footer } from '../../../core/data-models/footer';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    SvgInlineDirective,
    RouterModule,
    CommonModule,
    TranslateModule
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  contactInfo!: ContactData;
  private isBrowser: boolean;
  footer:Footer={
    description: '',
    links: []
  };
  constructor(private contactUsService: ContactUsService, private router: Router,
    private footerService: FooterService,
    @Inject(PLATFORM_ID) private platformId: Object
  ){
      this.isBrowser = isPlatformBrowser(this.platformId);
  }
  ngOnInit() {
  this.contactUsService.contactInfo$.subscribe((contactInfo: ContactData | null) => {
    if (contactInfo) {
      this.contactInfo = contactInfo;
    }
  });
  if(this.isBrowser){
    this.getFooter();
  }
  }
  goToTermsofUse(pageId: number) {
    this.router.navigate(['TermsofUse', pageId]);
  }
  
  goToPrivacyPolicy(pageId: number) {
    this.router.navigate(['PrivacyPolicy', pageId]);
  }

  getFooter(){
    this.footerService.getFooter().subscribe({
      next: (response:any) => {
        this.footer = response.data
        console.log(response);
      },
      error: (error) => {
        console.error('Error fetching footer:', error);
      }
    })
  }

  
  goToHome() {
    this.router.navigateByUrl("/home");
  }

}
